<template>
  <div class="lego-grid">
    <slot />
  </div>
</template>

<script>
export default {
  name: 'lego-grid',
};
</script>
